import { Injectable } from '@angular/core';
import { TranslateCompiler } from '@ngx-translate/core';
import IntlMessageFormat from 'intl-messageformat';

@Injectable()
export class IntlMessageFormatCompiler extends TranslateCompiler {
  private readonly mfCache = new Map<string, IntlMessageFormat>();

  compile(value: string, lang: string): string | Function {
    if (typeof value !== 'string') {
      return value;
    }

    if (!value.includes('{')) {
      return value;
    }

    try {
      const message = this.getMessageFormatInstance(value, lang);

      return (params: any = {}) => {
        try {
          const result = String(message.format(params));

          if (result.includes('{') && Object.keys(params || {}).length > 0) {
            const fallback = this.fallbackInterpolate(value, params);
            return fallback;
          }

          return result;
        } catch (error) {
          const fallback = this.fallbackInterpolate(value, params);
          return fallback;
        }
      };
    } catch (error) {
      return (params: any = {}) => {
        const fallback = this.fallbackInterpolate(value, params);
        return fallback;
      };
    }
  }

  compileTranslations(translations: any, lang: string): any {
    if (!translations || typeof translations !== 'object') {
      return translations;
    }

    const compiled: any = Array.isArray(translations) ? [] : {};

    Object.keys(translations).forEach((key) => {
      const value = translations[key];

      if (typeof value === 'string') {
        compiled[key] = this.compile(value, lang);
      } else if (value && typeof value === 'object') {
        compiled[key] = this.compileTranslations(value, lang);
      } else {
        compiled[key] = value;
      }
    });

    return compiled;
  }

  private getMessageFormatInstance(
    value: string,
    lang: string,
  ): IntlMessageFormat {
    const cacheKey = `${lang}:${value}`;

    let message = this.mfCache.get(cacheKey);

    if (!message) {
      message = new IntlMessageFormat(value, lang);
      this.mfCache.set(cacheKey, message);
    }

    return message;
  }

  private fallbackInterpolate(value: string, params: any): string {
    return value.replace(
      /\{\{\s*([^{}]+?)\s*\}\}|\{\s*([a-zA-Z0-9_.-]+)\s*\}/g,
      (match, doubleBracesKey, singleBracesKey) => {
        const key = doubleBracesKey || singleBracesKey;
        const result = params?.[key];

        return result === undefined || result === null
          ? match
          : String(result);
      },
    );
  }
}
